import { Component, OnInit } from '@angular/core';
import { AppHttpService } from 'app/app-http.service';
import { CartService } from '../cart.service';
import { SharedService } from 'app/shared.service';

@Component({
  selector: 'app-lottery-skl',
  templateUrl: './lottery-skl.component.html',
  styleUrls: ['./lottery-skl.component.scss']
})
export class LotterySklComponent implements OnInit {
  public lotteries = {
    products: []
  };
  public jokerLotteries = [];
  public sklLotteries = [];
  public productScopeId: Number;
  public jokerType: string;
  constructor(
    private httpService: AppHttpService,
    private cartService: CartService,
    private sharedService: SharedService
  ) {
    this.productScopeId = 16;
    this.cartService.setProductScope(this.productScopeId);

    this.getLotteries();
    this.jokerType = this.sharedService.getSessionStorage('jokerType');
  }

  ngOnInit() {}

  getLotteries(): void {
    this.httpService.getLotteries().subscribe((response) => {
      this.lotteries = this.cartService.getProductsWithAmount(response);
      this.jokerLotteries = this.lotteries.products.filter(
        (product) =>
          parseInt(product.id, 10) === 16 || parseInt(product.id, 10) === 17
      );
      this.sklLotteries = this.lotteries.products.filter(
        (product) =>
          parseInt(product.id, 10) !== 16 && parseInt(product.id, 10) !== 17
      );

      this.cartService.setLottery(response);
    });

    this.httpService.getMe().subscribe(
      (response) => {
        this.sharedService.setLoggedIn(true);
      },
      (error) => {
        this.sharedService.setLoggedIn(false);
      }
    );
  }
}
